import { Button } from '@components/Button/';
import Block from '@components/Layout/Block';
import { AdvisorHeadshot } from '@components/MiscComponents/AdvisorHeadShot';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import {
  Body,
  Container,
  ContentContainer,
  ContentWrapper,
  Eyebrow,
  GridImageContainer,
  GridTopContainer,
  Header,
  IndividualContainer,
} from '@components/ThreeColumn/styles';
import { observer } from 'mobx-react-lite';
import { useStores } from 'mobx/useStores';
import { FC } from 'react';

export interface ThreeColumnProps {
  header?: string;
  people?: {
    img: string;
    name: string;
    description: string;
    ctaText?: string;
    ctaUrl?: string;
  }[];
}

const ThreeColumn: FC<ThreeColumnProps> = observer(({ header, people }) => {
  const { appStore } = useStores();
  const { urlDomainOverride } = appStore;

  if (!people) {
    return null;
  }

  const blockWidth = people.length === 2 ? '60%' : '83.3333%';

  return (
    <Block width={blockWidth}>
      <Container>
        <GridTopContainer>
          <ContentContainer>{header && <Header>{header}</Header>}</ContentContainer>
        </GridTopContainer>
        <VerticalLineSeparator />
        <GridImageContainer
          $gridSize={
            people.length === 1
              ? 'repeat(1, 1fr)'
              : people.length === 2
              ? 'repeat(2, 1fr)'
              : 'repeat(3, 1fr)'
          }
        >
          {people &&
            people.map((obj, index) => (
              <IndividualContainer key={index}>
                <div>
                  <AdvisorHeadshot img={obj.img} alt_text="Person Image" />
                </div>
                <ContentWrapper>
                  <Eyebrow>{obj.name}</Eyebrow>
                  <Body>{obj.description}</Body>
                  {obj.ctaUrl && obj.ctaText && (
                    <div>
                      <Button
                        arrow={true}
                        variant={'tertiaryGray'}
                        url={`${urlDomainOverride ?? ''}${obj.ctaUrl}`}
                        label={obj.ctaText}
                      />
                    </div>
                  )}
                </ContentWrapper>
              </IndividualContainer>
            ))}
        </GridImageContainer>
      </Container>
    </Block>
  );
});

export default ThreeColumn;
